










































































































import { Vue, Component, Watch } from "vue-property-decorator";
import { ref, reactive, watch } from "@vue/composition-api";
import { ApkStore } from "@/modules/apk/apk.store";
import _cloneDeep from "lodash/cloneDeep";
import {
  ApkDetection,
  ApkNetworkTagNoticeItem,
  ApkNetworkTagAlgorithmItem
} from "@/modules/apk/apk.interface";
import {
  AppInformationItem,
  NewRuleItem,
  RuleHistoryItem
} from "@/modules/rule/rule.interface";
import { ApkService } from "@/modules/apk/apk.service";
import { RuleService } from "@/modules/rule/rule.service";
function useReasonDialog() {
  const visible = ref(false);
  const row = ref<any>(null);

  return reactive({
    visible,
    row
  });
}
@Component({
  metaInfo: {
    title: "规则详情"
  },
  beforeRouteLeave(to, from, next) {
    next();
  }
})
export default class extends Vue {
  @ApkStore.State apkNetworkTagAlgorithms!: ApkNetworkTagAlgorithmItem[];
  @ApkStore.State apkNetworkTagAlgorithmsLoading!: boolean;
  list: ApkNetworkTagNoticeItem[] | null = null;
  oneAppInformation: AppInformationItem;
  newRuleItem: NewRuleItem = {} as NewRuleItem;
  historyRuleList: RuleHistoryItem[] | null = null;
  listLoading = 0;
  reasonDialog = useReasonDialog();

  get packageName() {
    return this.$route.params.packageName;
  }

  get origin() {
    return this.$route.query.origin;
  }

  get appName() {
    return this.$route.query.app;
  }

  async goToHistory() {
    this.reasonDialog.visible = true;
    this.historyRuleList = await RuleService.getAllRuleHistoryIn(this.$route
      .query.id as string);
  }

  async postAppInfo() {
    this.newRuleItem.packageName = this.$route.query.packageName as string;
    this.newRuleItem.rules = this.list;
    this.newRuleItem.appName = this.oneAppInformation.appName;
    try {
      let result = await RuleService.postNewRuleIn(
        this.$route.query.id as string,
        this.newRuleItem as NewRuleItem
      ).then(() => {
        this.$notify({
          title: this.newRuleItem.appName,
          message: "编辑规则成功",
          type: "success"
        });
      });
    } catch {
      this.$notify.error({
        title: this.newRuleItem.appName,
        message: "编辑规则失败"
      });
    } finally {
      this.$router.push("/ware/defend");
    }
  }

  async created() {
    this.listLoading++;
    this.oneAppInformation = await RuleService.getOneAppWare(this.$route.query
      .id as string);
    this.list = this.oneAppInformation.rules;
    this.listLoading--;
  }

  goBack() {
    this.$router.push("/ware/defend");
  }

  /** 是否点击是否上传的开关时触发 */
  onIsAllowUploadChange(row: ApkNetworkTagNoticeItem, newVal) {
    row.isAllowUpload = newVal;
    if (!newVal) {
      row.reason = "";
      row.isAllowPlainText = true;
      row.algorithm = "";
      row.remarks = "";
    }
  }

  onIsAllowPlainTextChange(row: ApkNetworkTagNoticeItem, newVal) {
    row.isAllowPlainText = !newVal;
    if (!newVal) {
      row.algorithm = "";
      row.remarks = "";
    }
  }

  onAlgorithmChange(row: ApkNetworkTagNoticeItem, newVal) {
    row.algorithm = newVal;
    if (newVal) {
      row.remarks = "";
    }
  }
}
